export const currenciesDetails = {
  AED: { symbol: 'د.إ', display: 'right', space: true }, // UAE Dirham
  AFN: { symbol: '؋', display: 'left', space: false }, // Afghan Afghani
  ALL: { symbol: 'L', display: 'left', space: false }, // Albanian Lek
  AMD: { symbol: '֏', display: 'right', space: false }, // Armenian Dram
  ANG: { symbol: 'ƒ', display: 'left', space: false }, // Netherlands Antillean Guilder
  AOA: { symbol: 'Kz', display: 'left', space: false }, // Angolan Kwanza
  ARS: { symbol: '$', display: 'left', space: false }, // Argentine Peso
  AUD: { symbol: '$', display: 'left', space: false }, // Australian Dollar
  AWG: { symbol: 'ƒ', display: 'left', space: false }, // Aruban Florin
  AZN: { symbol: '₼', display: 'left', space: false }, // Azerbaijani Manat
  BAM: { symbol: 'KM', display: 'left', space: false }, // Bosnia-Herzegovina Convertible Mark
  BBD: { symbol: '$', display: 'left', space: false }, // Barbadian Dollar
  BDT: { symbol: '৳', display: 'left', space: false }, // Bangladeshi Taka
  BGN: { symbol: 'лв', display: 'right', space: false }, // Bulgarian Lev
  BIF: { symbol: 'FBu', display: 'left', space: false }, // Burundian Franc
  BMD: { symbol: '$', display: 'left', space: false }, // Bermudian Dollar
  BND: { symbol: '$', display: 'left', space: false }, // Brunei Dollar
  BOB: { symbol: 'Bs.', display: 'left', space: false }, // Bolivian Boliviano
  BRL: { symbol: 'R$', display: 'left', space: false }, // Brazilian Real
  BSD: { symbol: '$', display: 'left', space: false }, // Bahamian Dollar
  BWP: { symbol: 'P', display: 'left', space: false }, // Botswanan Pula
  BZD: { symbol: 'BZ$', display: 'left', space: false }, // Belize Dollar
  CAD: { symbol: '$', display: 'left', space: false }, // Canadian Dollar
  CDF: { symbol: 'FC', display: 'left', space: false }, // Congolese Franc
  CHF: { symbol: 'CHF', display: 'right', space: false }, // Swiss Franc
  CLP: { symbol: '$', display: 'left', space: false }, // Chilean Peso
  CNY: { symbol: '¥', display: 'left', space: false }, // Chinese Yuan
  COP: { symbol: '$', display: 'left', space: false }, // Colombian Peso
  CRC: { symbol: '₡', display: 'left', space: false }, // Costa Rican Colón
  CVE: { symbol: '$', display: 'left', space: false }, // Cape Verdean Escudo
  CZK: { symbol: 'Kč', display: 'right', space: false }, // Czech Republic Koruna
  DJF: { symbol: 'Fdj', display: 'left', space: false }, // Djiboutian Franc
  DKK: { symbol: 'kr', display: 'left', space: false }, // Danish Krone
  DOP: { symbol: 'RD$', display: 'left', space: false }, // Dominican Peso
  DZD: { symbol: 'د.ج', display: 'right', space: true }, // Algerian Dinar
  EGP: { symbol: '£', display: 'right', space: true }, // Egyptian Pound
  ETB: { symbol: 'Br', display: 'left', space: false }, // Ethiopian Birr
  EUR: { symbol: '€', display: 'right', space: true }, // Euro
  FJD: { symbol: '$', display: 'left', space: false }, // Fijian Dollar
  FKP: { symbol: '£', display: 'left', space: false }, // Falkland Islands Pound
  GBP: { symbol: '£', display: 'left', space: false }, // British Pound Sterling
  GEL: { symbol: '₾', display: 'left', space: false }, // Georgian Lari
  GIP: { symbol: '£', display: 'left', space: false }, // Gibraltar Pound
  GMD: { symbol: 'D', display: 'left', space: false }, // Gambian Dalasi
  GNF: { symbol: 'FG', display: 'left', space: false }, // Guinean Franc
  GTQ: { symbol: 'Q', display: 'left', space: false }, // Guatemalan Quetzal
  GYD: { symbol: '$', display: 'left', space: false }, // Guyanaese Dollar
  HKD: { symbol: '$', display: 'left', space: false }, // Hong Kong Dollar
  HNL: { symbol: 'L', display: 'left', space: false }, // Honduran Lempira
  HRK: { symbol: 'kn', display: 'left', space: false }, // Croatian Kuna
  HTG: { symbol: 'G', display: 'left', space: false }, // Haitian Gourde
  HUF: { symbol: 'Ft', display: 'left', space: false }, // Hungarian Forint
  IDR: { symbol: 'Rp', display: 'left', space: false }, // Indonesian Rupiah
  ILS: { symbol: '₪', display: 'left', space: false }, // Israeli New Sheqel
  INR: { symbol: '₹', display: 'left', space: false }, // Indian Rupee
  ISK: { symbol: 'kr', display: 'left', space: false }, // Icelandic Króna
  JMD: { symbol: 'J$', display: 'left', space: false }, // Jamaican Dollar
  JPY: { symbol: '¥', display: 'left', space: false }, // Japanese Yen
  KES: { symbol: 'KSh', display: 'left', space: false }, // Kenyan Shilling
  KGS: { symbol: 'лв', display: 'left', space: false }, // Kyrgystani Som
  KHR: { symbol: '៛', display: 'left', space: false }, // Cambodian Riel
  KMF: { symbol: 'CF', display: 'left', space: false }, // Comorian Franc
  KRW: { symbol: '₩', display: 'left', space: false }, // South Korean Won
  KYD: { symbol: '$', display: 'left', space: false }, // Cayman Islands Dollar
  KZT: { symbol: '₸', display: 'left', space: false }, // Kazakhstani Tenge
  LAK: { symbol: '₭', display: 'left', space: false }, // Laotian Kip
  LBP: { symbol: '£', display: 'right', space: true }, // Lebanese Pound
  LKR: { symbol: '₨', display: 'left', space: false }, // Sri Lankan Rupee
  LRD: { symbol: '$', display: 'left', space: false }, // Liberian Dollar
  LSL: { symbol: 'L', display: 'left', space: false }, // Lesotho Loti
  MAD: { symbol: 'MAD', display: 'right', space: true }, // Moroccan Dirham
  MDL: { symbol: 'L', display: 'left', space: false }, // Moldovan Leu
  MGA: { symbol: 'Ar', display: 'left', space: false }, // Malagasy Ariary
  MKD: { symbol: 'ден', display: 'left', space: false }, // Macedonian Denar
  MMK: { symbol: 'K', display: 'left', space: false }, // Myanmar Kyat
  MNT: { symbol: '₮', display: 'left', space: false }, // Mongolian Tugrik
  MOP: { symbol: 'MOP$', display: 'left', space: false }, // Macanese Pataca
  MUR: { symbol: '₨', display: 'left', space: false }, // Mauritian Rupee
  MVR: { symbol: 'Rf', display: 'left', space: false }, // Maldivian Rufiyaa
  MWK: { symbol: 'MK', display: 'left', space: false }, // Malawian Kwacha
  MXN: { symbol: '$', display: 'left', space: false }, // Mexican Peso
  MYR: { symbol: 'RM', display: 'left', space: false }, // Malaysian Ringgit
  MZN: { symbol: 'MT', display: 'left', space: false }, // Mozambican Metical
  NAD: { symbol: '$', display: 'left', space: false }, // Namibian Dollar
  NGN: { symbol: '₦', display: 'left', space: false }, // Nigerian Naira
  NIO: { symbol: 'C$', display: 'left', space: false }, // Nicaraguan Córdoba
  NOK: { symbol: 'kr', display: 'left', space: false }, // Norwegian Krone
  NPR: { symbol: '₨', display: 'left', space: false }, // Nepalese Rupee
  NZD: { symbol: '$', display: 'left', space: false }, // New Zealand Dollar
  PAB: { symbol: 'B/.', display: 'left', space: false }, // Panamanian Balboa
  PEN: { symbol: 'S/.', display: 'left', space: false }, // Peruvian Sol
  PGK: { symbol: 'K', display: 'left', space: false }, // Papua New Guinean Kina
  PHP: { symbol: '₱', display: 'left', space: false }, // Philippine Peso
  PKR: { symbol: '₨', display: 'left', space: false }, // Pakistani Rupee
  PLN: { symbol: 'zł', display: 'left', space: false }, // Polish Złoty
  PYG: { symbol: '₲', display: 'left', space: false }, // Paraguayan Guarani
  QAR: { symbol: 'ق.ر', display: 'right', space: true }, // Qatari Riyal
  RON: { symbol: 'lei', display: 'left', space: false }, // Romanian Leu
  RSD: { symbol: 'дин', display: 'left', space: false }, // Serbian Dinar
  RUB: { symbol: '₽', display: 'right', space: false }, // Russian Ruble
  RWF: { symbol: 'R₣', display: 'left', space: false }, // Rwandan Franc
  SAR: { symbol: '﷼', display: 'right', space: false }, // Saudi Riyal
  SBD: { symbol: '$', display: 'left', space: false }, // Solomon Islands Dollar
  SCR: { symbol: '₨', display: 'left', space: false }, // Seychellois Rupee
  SEK: { symbol: 'kr', display: 'left', space: false }, // Swedish Krona
  SGD: { symbol: '$', display: 'left', space: false }, // Singapore Dollar
  SHP: { symbol: '£', display: 'left', space: false }, // Saint Helena Pound
  SLL: { symbol: 'Le', display: 'left', space: false }, // Sierra Leonean Leone
  SRD: { symbol: '$', display: 'left', space: false }, // Surinamese Dollar
  STD: { symbol: 'Db', display: 'left', space: false }, // São Tomé and Príncipe Dobra
  SZL: { symbol: 'L', display: 'left', space: false }, // Swazi Lilangeni
  THB: { symbol: '฿', display: 'left', space: false }, // Thai Baht
  TJS: { symbol: 'ЅМ', display: 'left', space: false }, // Tajikistani Somoni
  TOP: { symbol: 'T$', display: 'left', space: false }, // Tongan Paʻanga
  TRY: { symbol: '₺', display: 'left', space: false }, // Turkish Lira
  TTD: { symbol: 'TT$', display: 'left', space: false }, // Trinidad and Tobago Dollar
  TWD: { symbol: 'NT$', display: 'left', space: false }, // New Taiwan Dollar
  TZS: { symbol: 'Sh', display: 'left', space: false }, // Tanzanian Shilling
  UAH: { symbol: '₴', display: 'left', space: false }, // Ukrainian Hryvnia
  UGX: { symbol: 'USh', display: 'left', space: false }, // Ugandan Shilling
  USD: { symbol: '$', display: 'left', space: false }, // United States Dollar
  UYU: { symbol: '$U', display: 'left', space: false }, // Uruguayan Peso
  UZS: { symbol: 'лв', display: 'left', space: false }, // Uzbekistani Som
  VND: { symbol: '₫', display: 'right', space: false }, // Vietnamese Dong
  VUV: { symbol: 'VT', display: 'left', space: false }, // Vanuatu Vatu
  WST: { symbol: 'WS$', display: 'left', space: false }, // Samoan Tala
  XAF: { symbol: 'FCFA', display: 'right', space: true }, // CFA Franc BEAC
  XCD: { symbol: '$', display: 'left', space: false }, // East Caribbean Dollar
  XOF: { symbol: 'CFA', display: 'right', space: true }, // CFA Franc BCEAO
  XPF: { symbol: '₣', display: 'right', space: true }, // CFP Franc
  YER: { symbol: '﷼', display: 'right', space: false }, // Yemeni Rial
  ZAR: { symbol: 'R', display: 'left', space: false }, // South African Rand
  ZMW: { symbol: 'ZK', display: 'left', space: false }, // Zambian Kwacha
}
